import { render } from "./RegisterKit.vue?vue&type=template&id=610640d5&scoped=true"
import script from "./RegisterKit.vue?vue&type=script&lang=js"
export * from "./RegisterKit.vue?vue&type=script&lang=js"

import "./RegisterKit.vue?vue&type=style&index=0&id=610640d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610640d5"]])

export default __exports__